import React, { useRef } from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import InterestedInUsedGMC from './InterestedInUsedGMC';

const ClpGetAnAutoLoanInBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="Get An Auto Loan Today! Fast Application Process"
                description="Want to get auto financing in Boerne & Austin, Texas? The Mark Motors has this page where we tell you how you can apply for an auto loan at our dealership!"
                keywords="Get an Auto Loan in Boerne, Texas"
                ogTitle="Get An Auto Loan Today! Fast Application Process"
                ogDescription="Want to get auto financing in Boerne & Austin, Texas? The Mark Motors has this page where we tell you how you can apply for an auto loan at our dealership!"
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">
                        <Link to="/applyforcredit-boerne">
                            <img src={getImages('new/Auto_loan_b414775051_b.jpg')} alt='A man holding a key chain' />
                        </Link>
                        <h1>Get an Auto Loan in Boerne, Texas</h1>
                        <p>If you have been driving your current vehicle for a long time, it may be time for a new one. While you can go for a new car, you can also opt for a used one. In both cases, you would need auto financing at a reasonable interest rate,
                            and this is where we come in. Mark Motors in Boerne, Texas, has this page where we discuss how you can apply for an auto loan with us. Check it out!
                        </p>
                        <div className="mt-3">
                            <Link className="btn-theme md-btn me-4 d-inline-block" to="/applyforcredit-boerne">Get an Auto Loan</Link>
                        </div>
                        <h2>How Do I Apply for Auto Financing at Mark Motors? &nbsp;</h2>
                        <p>To apply for an auto loan at our dealership, you are required to fill out an online application form. Firstly, you need to mention your personal information, such as your name, phone number, email address, etc. Next, you must provide
                            your residential details and employment details. After that, you have to mention your financial information. Once you are done filling out the form, you can hit send. &nbsp;&nbsp;</p>
                        <p>After receiving your application, our finance team will collaborate with banks and various financial organizations to develop a loan package that is not hard on your wallet. Once your loan is approved, you can choose any vehicle
                            from our exhaustive inventory. Our dealership has different types of vehicles from various reputable brands, such as Mercedes-Benz, Dodge, Audi, BMW, Lamborghini, Nissan, Ford, Tesla, etc. Therefore, you can buy the vehicle
                            that best serves your requirements and is within your budget. &nbsp;&nbsp;</p>
                        <p>If you have any queries about the finance application process or the vehicles in our inventory, you can reach us at 830-981-5050. You can also visit our dealership in person whenever you get the time off your busy schedule. We
                            will be excited to give you a tour of our inventory and answer any questions you may have for us. &nbsp;</p>

                        <div className="row gx-4 mt-5">
                            <div className="col-md-4">
                                <img src={getImages('new/Auto_loan_b4120773411_b.jpg')} alt='A man calculating on a calculator' />
                            </div>
                            <div className="col-md-4">
                                <img src={getImages('new/Auto_loan_b4127737411_b.jpg')} alt='A calculator with APR on the screen' />
                            </div>
                            <div className="col-md-4">
                                <img src={getImages('new/Auto_loan_b41475051_b.jpg')} alt='A man working on a calculator and a laptop' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ClpGetAnAutoLoanInBoerneTexas